import {
  joinApiNewCar,
  NEW_CAR_API_VERSION_V1,
} from '@/utils/url/join/private';

import type {
  CamelCaseAdAlert,
  CamelCaseCarAlert,
  ConvertToCamelCaseAdAlertList,
  ConvertToCamelCaseCarAlertList,
  ConvertToCamelCaseResponseBody,
  ConvertToCamelCaseResponseData,
  CreateGetMyAlertListRequestUrl,
} from './types';

export const createGetMyAlertListRequestUrl: CreateGetMyAlertListRequestUrl = ({ // @suppress longLineCheck
  memberId,
  sessionId,
}) => {
  const url = joinApiNewCar({
    path: '/my-alert-list',
    version: NEW_CAR_API_VERSION_V1,
  });
  const { searchParams } = url;

  searchParams.set('member_id', `${memberId ?? ''}`);
  searchParams.set('session_id', `${sessionId ?? ''}`);

  return url;
};

export const convertToCamelCaseAdAlertList: ConvertToCamelCaseAdAlertList = list => list.map(({ // @suppress longLineCheck
  make,
  ad_promo: adPromo,
  ad_car_launches: adCarLaunches,
}) => ({
  make,
  adPromo,
  adCarLaunches,
}));

export const convertToCamelCaseCarAlertList: ConvertToCamelCaseCarAlertList = list => list.map(({ // @suppress longLineCheck
  car_id: carId,
  ad_car_price_change: adCarPriceChange,
  pi_car_promo: piCarPromo,
}) => ({
  carId,
  adCarPriceChange,
  piCarPromo,
}));

export const convertToCamelCaseResponseData: ConvertToCamelCaseResponseData = ({
  ad_alerts: adAlerts,
  car_alerts: carAlerts,
}) => ({
  adAlerts: convertToCamelCaseAdAlertList(adAlerts),
  carAlerts: convertToCamelCaseCarAlertList(carAlerts),
});

export const convertToCamelCaseResponseBody: ConvertToCamelCaseResponseBody = ({
  data,
}) => ({
  data: convertToCamelCaseResponseData(data),
});

export const isCamelCaseAdAlert = (
  alert: CamelCaseAdAlert | CamelCaseCarAlert,
): alert is CamelCaseAdAlert => (alert as CamelCaseAdAlert).make !== undefined;

export const isCamelCaseCarAlert = (
  alert: CamelCaseAdAlert | CamelCaseCarAlert,
): alert is CamelCaseCarAlert => (
  alert as CamelCaseCarAlert
).carId !== undefined;
